// extracted by mini-css-extract-plugin
module.exports = {"block":"VerifiedBadge_block__DOetC","tier":"VerifiedBadge_tier__ZW4rv"};